import { ToolbarButton, ToolbarWrapper } from './toolbar';

/**
 * The `Toolbar` namespace object the app has always exported — preserved
 * verbatim so every `Toolbar.Wrapper` / `Toolbar.Button` call site keeps
 * working through the facade (6.5/6.6 groundwork).
 */
export const Toolbar = {
  Wrapper: ToolbarWrapper,
  Button: ToolbarButton,
};
